// contacts routes

const routes = [
  {
    path: "/contacts",
    name: "ContactsHome",
    component: () => import("@/views/contacts/ContactsHome.vue"),
    meta: { requiresAuth: true, app: "contacts" },
  },
  {
    path: "/contacts/credentials",
    name: "ContactsCredentials",
    component: () => import("@/views/contacts/CredentialsPage.vue"),
    // The shared logins: an Operator with the FULL Contacts grant (the server says the same)
    meta: { requiresAuth: true, requiresAdmin: true, app: "contacts", editOnly: true },
  },
];

export default routes;
